<div class="w-full">
  <app-image [url]="(data?.imgUrl || data?.imageUrl) | cdnBaseUrl"></app-image>
</div>
